<template>
    <!-- 填写表格 操作栏 -->
    <div id="operateBtn" class="flex_icon">
        <!-- 新增一行 -->
        <el-tooltip class="item" effect="light" content="新建行" placement="top">
          <el-button link type='text' icon="el-icon-plus" @click="addRow()" />
        </el-tooltip>
        <!-- 移除一行 -->
        <el-tooltip class="item" effect="light" content="移除行" placement="top">
          <el-button link type='text' icon="el-icon-minus" @click="removeRow()" />
        </el-tooltip>
        <!-- 复制 -->
        <el-tooltip class="item" effect="light" content="复制行" placement="top" v-if="isShow">
          <el-button link type='text' icon="el-icon-copy-document" @click="copyRow()" />
        </el-tooltip>
        <!-- 拖拽排序 -->
        <el-tooltip class="item" effect="light" content="上下拖动排序" placement="top" v-if="$route.name === 'FormCreateView'">
          <el-button :class="['icon', forbidden ? 'forbidden' : 'drag_handle']" link type='text' icon="el-icon-d-caret" />
        </el-tooltip>
    </div>
</template>

<script>
export default {
  name: 'TableOperationBar',
  props: {
    // 是否禁止拖拽排序
    forbidden: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShow: this.$route.name === 'ProtocolCreateView' || this.$route.name === 'FormCreateView' || false // 仅协议管理的编辑和新增页面显示
    }
  },
  methods: {
    // 新增一行
    addRow () {
      this.$emit('addRow')
    },
    // 移除一行
    removeRow () {
      this.$emit('removeRow')
    },
    // 复制一行
    copyRow () {
      this.$emit('copyRow')
    }
  }
}
</script>

<style>
/* @import url(@/assets/styles/img.css); */
.flex_icon{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size:20px ;
}
.drag_handle{
  cursor: grab;
}
.forbidden{
  cursor: not-allowed;
}
</style>
